import { render } from "./FollowersCountStep.vue?vue&type=template&id=169bf9c9&ts=true"
import script from "./FollowersCountStep.vue?vue&type=script&lang=ts"
export * from "./FollowersCountStep.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__